<!--page starts-->
<section class="page-wrapper">
    <div class="commercial-top-section margin-top-152 cf" [ngStyle]="{'background-image':'url(' + bannerList?.file + ')'}">
        <div class="container">
            <div class="commercial-top-tab-list ">
                <div class="commercial-top-tab-list-inner">
                    <div class="commercial-top-tab-list-detail">
                        <ul>
                            <li><a routerLink="/ground-regulations">About Us</a></li>
                            <li><a routerLink="/club/premier-outdoor-venue" >Uptonsteel County Ground</a></li>
                            <!-- <li><a routerLink="/recruitment" >Recruitment</a></li> -->
                            <li><a routerLink="/contact" class="active" > Contact Us</a></li>                                                          
                        </ul>
                    </div>
                    <div class="commercial-top-mouse">
                        <div class="commercial-top-mouse-img">
                            <img src="assets/images/mouse.svg">
                        </div>
                        <p>scroll for details</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="commercial-top-overlay">
        </div>
    </div>
    <div class="club-contact-section">
        <div class="club-contact-tab-section">
            <div class="container">
                <div class="club-contact-tab">
                    <ul>
                        <li class="courses-name " id="patrons-officials"><a href="#">Patrons & Officials </a></li>
                        <li class="courses-name active" id="contacts"><a href="#">Contact Us</a></li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="club-contact-tab-detail-section">
            <div class="container">
                <div class="club-contact-tab-detail">
                    <div class="club-contact-patrons course-main-content " id="patrons-officials-content">
                        <div class="titel-box" *ngIf="patronsList?.data?.length > 0">
                            <h2 class="titel-name">Patrons & Officials</h2>
                        </div>
                        <div class="club-contact-patrons-detail" *ngIf="patronsList?.data?.length > 0">
                            <table>
                                <tr *ngFor="let patrons of patronsList?.data">
                                    <td class="patrons-name">{{patrons?.job_title}}</td>
                                    <td class="patrons-content">{{patrons?.name}}</td>
                                </tr>
                               
                            </table>
                        </div>
                    </div>
                    <div class="club-contact-contacts course-main-content active" id="contacts-content">
                        <div class="titel-box" *ngIf="contactList?.data?.length > 0">
                            <h2 class="titel-name">Contact Us</h2>
                        </div>
                        <div class="club-contact-contacts-detail" *ngIf="contactList?.data?.length > 0">
                            <div class="club-contact-contacts-box">
                                <ul>
                                    <li *ngFor="let contact of contactList?.data">{{contact?.job_title}}<span>{{contact?.name}}</span></li>                                  
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section><!-- page ends-->